import { t } from '@lingui/macro';
import { FC, ReactNode } from 'react';

import logo from '@/assets/images/login_logo.png';
import LoginLanguageSwitch from '@/components/Login/LoginLanguageSwitch';

import AppButton from '../AppButton/AppButton';
import Version from '../Version/Version';

import classes from './authWrapp.module.css';

type TNodeChild = string | ReactNode;
type IProps = {
    header?: TNodeChild;
    subHeader?: TNodeChild;
    children?: TNodeChild;
};

const AuthLayout: FC<IProps> = props => {
    const { header = '', subHeader = '', children = <></> } = props;

    const versionURL =
        process.env.REACT_APP_DIST === 'beta'
            ? 'https://web.cht-root.com'
            : 'https://web-beta.cht-root.com';

    const link =
        process.env.REACT_APP_DIST === 'beta'
            ? t`Use Stable Version`
            : t`Use Beta Version`;

    return (
        <div className="justifyCenter d-flex">
            <div className="centerContainer">
                <div className={classes['contentWrapper']}>
                    <img alt="" src={logo} className={classes['logo']} />

                    <div className={classes['headingWrapper']}>
                        <h1 className="primaryHeading marginVertical-small">
                            {header}
                        </h1>
                        <span className="subHeading margin text-sm-center">
                            {subHeader}
                        </span>
                    </div>

                    {children}

                    <a href={versionURL}>
                        <AppButton
                            title={link}
                            onClick={() => {}}
                            type="button"
                            buttonType={'whiteWithBorder'}
                            classStyles={classes['appButton']}
                        />
                    </a>

                    <Version />

                    <div>
                        <LoginLanguageSwitch />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AuthLayout;
